import React, { useEffect, useState } from 'react';
import Link from '../components/Link';
import { motion } from 'framer-motion';
import { Mail, Lock, User, UserPlus, CheckCircle, XCircle, Eye, EyeOff } from 'lucide-react';
// import { supabase } from '../lib/supabase';
import ImagesDev from '../api/images';
import { checkLoginStatus, registerUser, checkUsernameAvailability, checkEmailAvailability, loginUser } from '../api/authService';
import { Toast, ToastContainer } from '../components/Toast';

const supabase = []

export default function Register() {
    const [isLoading, setIsLoading] = useState(false);
    const [bgImage, setBgImage] = useState("");
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        display_name: '',
        isUsernameAvailable: false,
        isEmailAvailable: false
    });

    useEffect(() => {
        setBgImage(getRandomHeroImage())
    }, [])

    useEffect(() => {
        const verifyUser = async () => {
            const isAuthenticated = await checkLoginStatus();
            if (isAuthenticated) {
                window.location.href = "/profile"; // Redirect if not logged in
            }
        };
        verifyUser();
    }, []);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    
    //     if (formData.password !== formData.confirmPassword) {
    //         Toast.error('Passwords do not match');
    //         setIsLoading(false);
    //         return;
    //     }
    
    //     try {
    //         const { success, message } = await registerUser({
    //             email: formData.email,
    //             password: formData.password,
    //             username: formData.display_name
    //         });
    
    //         if (!success) throw new Error(message);
    
    //         Toast.success('Registration successful! Please check your email to verify your account.');
    //     } catch (error) {
    //         if (error.message.includes("already exists")) {
    //             Toast.error("Username or Email is already taken.");
    //         } else {
    //             Toast.error(error.message || 'Failed to register');
    //         }
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const handleSubmit_ = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Check if passwords match
        if (formData.password !== formData.confirmPassword) {
            Toast.error('Passwords do not match');
            setIsLoading(false);
            return;
        }
    
        // Check if username is available
        if (formData.isUsernameAvailable === false) {
            Toast.error('Display name is not available. Please choose another one.');
            setIsLoading(false);
            return;
        }
    
        // Check if email is available
        if (formData.isEmailAvailable === false) {
            Toast.error('Email is already in use. Try logging in.');
            setIsLoading(false);
            return;
        }
    
        try {
            const { success, token, message } = await registerUser({
                email: formData.email,
                password: formData.password,
                username: formData.display_name
            });
    
            if (!success) throw new Error(message);
    
            // Store token and redirect if registration is successful
            if (token) {
                localStorage.setItem('token', token);
                Toast.success('Registration successful! You are now logged in.');
                window.location.href = "/";
            } else {
                Toast.success('Registration successful! Please check your email to verify your account.');
            }
        } catch (error) {
            if (error.message.includes("already exists")) {
                Toast.error("Username or Email is already taken.");
            } else {
                Toast.error(error.message || 'Failed to register');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Check if passwords match
        if (formData.password !== formData.confirmPassword) {
            Toast.error('Passwords do not match');
            setIsLoading(false);
            return;
        }
    
        // Check if username and email are available
        if (!formData.isUsernameAvailable) {
            Toast.error('Display name is not available. Please choose another one.');
            setIsLoading(false);
            return;
        }
    
        if (!formData.isEmailAvailable) {
            Toast.error('Email is already in use. Try logging in.');
            setIsLoading(false); 
            return;
        }
    
        try {
            // Register the user
            const { success, message } = await registerUser({
                email: formData.email,
                password: formData.password,
                username: formData.display_name
            });
    
            if (!success) throw new Error(message);
    
            // **Immediately log the user in**
            const loginResponse = await loginUser(formData.display_name, formData.password);
            
            if (!loginResponse.success) throw new Error(loginResponse.message);
    
            // **Store the token and redirect**
            // localStorage.setItem('token', loginResponse.token);
            Toast.success('Registration successful! Please check your email for the verification link to verify your account!');
            window.location.href = "/";
            
        } catch (error) {
            Toast.error(error.message || 'Failed to register');
        } finally {
            setIsLoading(false);
        }
    };

    const getRandomHeroImage = () => {
        const images = window.innerWidth > 768 ? ImagesDev.heroImagesDesk : ImagesDev.heroImages;
        return images[Math.floor(Math.random() * images.length)];
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
        >
            <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.4 }}
                transition={{ duration: 2 }}
                className='absolute top-0 left-0 h-full w-full'
                src={bgImage}
                style={{ objectFit: "cover" }}
            />
            <div className="container mx-auto px-4">
                <div className="max-w-md mx-auto pt-10">
                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10"
                    >
                        <div className="text-center mb-8">
                            <h1 className="text-3xl font-bold mb-2">Create Account</h1>
                            <p className="text-gray-400">Join our community today</p>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            {/* <div>
                                <label className="block text-sm font-medium mb-2">Display Name</label>
                                <div className="relative">
                                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="text"
                                        name="display_name"
                                        value={formData.display_name}
                                        onChange={handleChange}
                                        className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
                                        required
                                    />
                                </div>
                            </div> */}
                            {/* <p>{JSON.stringify(formData)}</p> */}
                            <DisplayNameInput value={formData.display_name} onChange={handleChange} />

                            <EmailInput value={formData.email} onChange={handleChange} />

                            <PasswordFields formData={formData} setFormData={setFormData} />

                            <motion.button
                                type="submit"
                                disabled={isLoading}
                                className="w-full py-3 bg-gradient-to-r from-tc-gold to-orange-600 text-white rounded-lg hover:from-tc-gold hover:to-orange-700 transition-all duration-300 flex items-center justify-center space-x-2"
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                            >
                                <UserPlus className="w-5 h-5" />
                                <span>{isLoading ? 'Creating account...' : 'Create Account'}</span>
                            </motion.button>
                        </form>

                        <div className="mt-6 text-center">
                            <p className="text-gray-400">
                                Already have an account?{' '}
                                <Link
                                    to="/login"
                                    className="text-orange-400 hover:text-orange-300 transition-colors"
                                >
                                    Sign in
                                </Link>
                            </p>
                        </div>
                    </motion.div>
                </div>
            </div>
        </motion.div>
    );
}









// const DisplayNameInput = ({ value, onChange }) => {
//     const [username, setUsername] = useState(value);
//     const [isAvailable, setIsAvailable] = useState(null);
//     const [suggestions, setSuggestions] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // Debounce effect: Waits 500ms after the user stops typing
//     useEffect(() => {
//         if (!username) return;

//         const delay = setTimeout(async () => {
//             setLoading(true);
//             const available = await checkUsernameAvailability(username);
//             setIsAvailable(available);
//             setLoading(false);

//             if (!available) {
//                 generateSuggestions(username);
//             } else {
//                 setSuggestions([]);
//             }
//         }, 500);

//         return () => clearTimeout(delay);
//     }, [username]);

//     // Generates three alternative usernames
//     const generateSuggestions = (base) => {
//         const randomNumber = () => Math.floor(Math.random() * 1000);
//         setSuggestions([
//             `${base}${randomNumber()}`,
//             `${base}_${randomNumber()}`,
//             `${base}${randomNumber()}xyz`,
//         ]);
//     };

//     // Handle input change
//     const handleChange = (e) => {
//         const newValue = e.target.value;
//         setUsername(newValue);
//         onChange({ target: { name: "display_name", value: newValue } }); // Updates the parent form
//     };

//     return (
//         <div>
//             <label className="block text-sm font-medium mb-2">Display Name</label>
//             <div className="relative">
//                 <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
//                 <input
//                     type="text"
//                     name="display_name"
//                     value={username}
//                     onChange={handleChange}
//                     className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
//                     required
//                 />
//                 {loading ? (
//                     <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">Checking...</div>
//                 ) : isAvailable !== null && (
//                     <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         {isAvailable ? (
//                             <CheckCircle className="text-green-500 w-5 h-5" />
//                         ) : (
//                             <XCircle className="text-red-500 w-5 h-5" />
//                         )}
//                     </div>
//                 )}
//             </div>

//             {!isAvailable && suggestions.length > 0 && (
//                 <div className="mt-2 text-sm text-gray-400">
//                     <p className="mb-1">Try one of these:</p>
//                     <div className="flex space-x-2">
//                         {suggestions.map((suggestion) => (
//                             <button
//                                 key={suggestion}
//                                 type="button"
//                                 className="px-3 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-all"
//                                 onClick={() => {
//                                     setUsername(suggestion);
//                                     onChange({ target: { name: "display_name", value: suggestion } });
//                                     setIsAvailable(true);
//                                     setSuggestions([]);
//                                 }}
//                             >
//                                 {suggestion}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };


const DisplayNameInput = ({ value, onChange }) => {
    const [username, setUsername] = useState(value || ""); // Ensure initial state isn't undefined
    const [isAvailable, setIsAvailable] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (username.length < 4) {
            setIsAvailable(null);
            setSuggestions([]);
            return;
        }

        const delay = setTimeout(async () => {
            setLoading(true);
            const available = await checkUsernameAvailability(username);
            setIsAvailable(available);
            setLoading(false);

            if (!available) {
                generateSuggestions(username);
            } else {
                setSuggestions([]);
            }
        }, 500);

        return () => clearTimeout(delay);
    }, [username]);

    useEffect(() => {
        updateForm_IsAvailable();
    }, [username, isAvailable]);

    const generateSuggestions = (base) => {
        const randomNumber = () => Math.floor(Math.random() * 1000);
        setSuggestions([
            `${base}${randomNumber()}`,
            `${base}_${randomNumber()}`,
            `${base}${randomNumber()}xyz`,
        ]);
    };

    const handleChange = (e) => {
        const newValue = e.target.value
            .replace(/\s+/g, "_")  // Replace spaces with underscores
            .replace(/[^a-zA-Z0-9_]/g, ""); // Remove all special characters except underscores
    
        setUsername(newValue);
        onChange({ target: { name: "display_name", value: newValue } });
        
    };

    const updateForm_IsAvailable = () => {
        if (username.length >= 4 && isAvailable === true) {
            onChange({ target: { name: "isUsernameAvailable", value: true } });
        } else {
            onChange({ target: { name: "isUsernameAvailable", value: false } });
        }
    }

    return (
        <div>
            <label className="block text-sm font-medium mb-2">Display Name</label>
            <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="text"
                    name="display_name"
                    value={username}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
                    required
                />
                {username.length > 0 && username.length < 4 ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-yellow-500">
                        Too short!
                    </div>
                ) : loading ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">Checking...</div>
                ) : isAvailable !== null && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isAvailable ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : (
                            <XCircle className="text-red-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {username.length >= 4 && !isAvailable && suggestions.length > 0 && (
                <div className="mt-2 text-sm text-gray-400">
                    <p className="mb-1">Try one of these:</p>
                    <div className="flex space-x-2">
                        {suggestions.map((suggestion) => (
                            <button
                                key={suggestion}
                                type="button"
                                className="px-3 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-all"
                                onClick={() => {
                                    setUsername(suggestion);
                                    onChange({ target: { name: "display_name", value: suggestion } });
                                    setIsAvailable(true);
                                    setSuggestions([]);
                                }}
                            >
                                {suggestion}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};


const EmailInput = ({ value, onChange }) => {
    const [email, setEmail] = useState(value || "");
    const [isValid, setIsValid] = useState(true);
    const [isAvailable, setIsAvailable] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) {
            setIsValid(true);
            setIsAvailable(null);
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValid(emailRegex.test(email));

        // If not valid, don't check availability
        if (!emailRegex.test(email)) {
            setIsAvailable(null);
            return;
        }

        // Debounced check for email availability
        const delay = setTimeout(async () => {
            setLoading(true);
            const available = await checkEmailAvailability(email);
            setIsAvailable(available);
            setLoading(false);
        }, 500);

        return () => clearTimeout(delay);
    }, [email]);

    useEffect(() => {
        updateForm_IsAvailable();
    }, [email, isAvailable, isValid]);

    const handleChange = (e) => {
        setEmail(e.target.value);
        onChange({ target: { name: "email", value: e.target.value } });
    };

    const updateForm_IsAvailable = () => {
        if (email.length >= 4 && isAvailable === true && isValid === true) {
            onChange({ target: { name: "isEmailAvailable", value: true } });
        } else {
            onChange({ target: { name: "isEmailAvailable", value: false } });
        }
    }

    return (
        <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-600 focus:border-transparent transition-all duration-300"
                    required
                />
                {loading ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        Checking...
                    </div>
                ) : isValid && isAvailable !== null && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isAvailable ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : (
                            <XCircle className="text-red-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {!isValid && email.length > 0 && (
                <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
            )}

            {isValid && isAvailable === false && (
                <p className="text-red-500 text-sm mt-1">
                    This email is already in use. <a href="/login" className="text-amber-500 underline">Log in</a> instead?
                </p>
            )}
        </div>
    );
};


const PasswordFields = ({ formData, setFormData }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [strength, setStrength] = useState("");

    // Determine password strength
    const getPasswordStrength = (pass) => {
        if (pass.length < 6) return "Too short";
        if (pass.match(/[A-Z]/) && pass.match(/[0-9]/) && pass.match(/[@$!%*?&#]/)) {
            return "Strong";
        }
        if (pass.match(/[A-Z]/) || pass.match(/[0-9]/) || pass.match(/[@$!%*?&#]/)) {
            return "Medium";
        }
        return "Weak";
    };

    // Handle password input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        if (name === "password") {
            setStrength(getPasswordStrength(value));
        }
    };

    return (
        <div>
            {/* Password Field */}
            <div>
                <label className="block text-sm font-medium mb-2">Password</label>
                <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="w-full pl-10 pr-10 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                        required
                        minLength={6}
                    />
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <EyeOff /> : <Eye />}
                    </button>
                </div>
                {formData.password && (
                    <p
                        className={`mt-2 text-sm ${
                            strength === "Strong" ? "text-green-500" : strength === "Medium" ? "text-yellow-500" : "text-red-500"
                        }`}
                    >
                        {strength}
                    </p>
                )}
            </div>

            {/* Confirm Password Field */}
            <div className="mt-4">
                <label className="block text-sm font-medium mb-2">Confirm Password</label>
                <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        className="w-full pl-10 pr-10 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:border-transparent transition-all duration-300"
                        required
                    />
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                        {showConfirmPassword ? <EyeOff /> : <Eye />}
                    </button>
                </div>
                {formData.confirmPassword && (
                    <p
                        className={`mt-2 text-sm ${
                            formData.password === formData.confirmPassword ? "text-green-500" : "text-red-500"
                        }`}
                    >
                        {formData.password === formData.confirmPassword ? (
                            <span className="flex items-center">
                                <CheckCircle className="w-4 h-4 mr-1 text-green-500" />
                                Passwords match
                            </span>
                        ) : (
                            <span className="flex items-center">
                                <XCircle className="w-4 h-4 mr-1 text-red-500" />
                                Passwords do not match
                            </span>
                        )}
                    </p>
                )}
            </div>
        </div>
    );
};